module.exports = __webpack_public_path__ + "img/Scissors.9a5a65ba.svg";